/**
 * Decodes a JWT token and returns the payload as a JavaScript object.
 *
 * @param {string | null | undefined} token - The JWT token to decode.
 * @returns {any} The decoded payload of the JWT token.
 * @throws {Error} If the token format is invalid.
 */
export function decodeJwtToken(token?: string | null): any {
  if (!token)
    return {}
  const parts = token.split('.')
  if (parts.length !== 3) {
    throw new Error('Invalid token format')
  }

  const payload = parts[1]
  const padding = '='.repeat((4 - payload.length % 4) % 4)
  const base64 = (payload + padding).replace(/-/g, '+').replace(/_/g, '/')

  const rawPayload = atob(base64)
  const decodedPayload = decodeURIComponent(
    Array.from(rawPayload).map((char) => {
      return `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`
    }).join(''),
  )
  return JSON.parse(decodedPayload)
}
